import type { NavZone } from './sidebarNav';

/**
 * Every vertical's group in the books' sidebar (vsidebar-onerow, founder 4 Nov 2026: "make
 * everything exactly as practice"). Since vsidebar-a a vertical carries its own desks in its own
 * sidebar, so in the books' sidebar each vertical is one row, its door: Health, Travel and Studio
 * used to open a dropdown of desks there as well, a second copy of the list that the door opens.
 */
export const VERTICAL_DOOR_GROUPS: ReadonlySet<string> = new Set([
    'grp-practice-desk', 'grp-lab', 'grp-build', 'grp-travel', 'grp-me', 'grp-fleet', 'grp-mandi',
    'grp-stay', 'grp-campus', 'grp-jewel', 'grp-studio', 'grp-service',
]);

/**
 * Keep only the door of each vertical's group: its first row left after gating. The desks stay in
 * the tree (modules, the tour and Ctrl+K read them) and show in the vertical's own sidebar.
 */
export function verticalDoorsOnly(zones: NavZone[]): NavZone[] {
    return zones.map(zone => ({
        ...zone,
        groups: zone.groups.map(group => (
            VERTICAL_DOOR_GROUPS.has(group.id) && group.items.length > 1
                ? { ...group, items: group.items.slice(0, 1) }
                : group
        )),
    }));
}
